window.addEventListener("turbolinks:load", () => {
    const element = document.querySelector("#service-appointment");
    if (element != null) {
      element.addEventListener("ajax:success", (event) => {
        const [_data, _status, xhr] = event.detail;
        element.innerHTML = xhr.responseText;
        $('#days-to-appointment').remove();
        document.dispatchEvent(new CustomEvent('appointment:content-updated'));
      });
      element.addEventListener("ajax:error", (event) => {
        const [_data, _status, xhr] = event.detail;
        alert(xhr.responseText)
      });
    }
  });
